import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initColorScheme } from '../shared/theme/colorScheme';

import { App } from './App';
import { AppProviders } from './providers/AppProviders';
import '../shared/theme/base.css';

// Before render: the dark token set is keyed on [data-theme], so without this
// the reader's OS preference is ignored entirely.
initColorScheme();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
